/**
 * @file: IM模块
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2022-05-25 11:01:01
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2023-10-31 13:53:14
 * @FilePath: /console-znzs/src/vuex/chat.module.js
 */
import Vue from 'vue';
import {Message} from 'element-ui';
import {cleanSingleUnreadMsg, getIMSessions, sendMessage} from '@/znzs/src/api/chat';
import {isIninWhitelist} from '@/znzs/src/api/robot';
import {constant, DIALOG_TYPE, CHANNEL, DISPLAY_TYPE} from '@/znzs/src/utils/enum';
import {loadEvent} from '@/znzs/src/utils';
import {getTicket} from '@/znzs/src/utils/chat';
import createWebSocket from '@/znzs/src/utils/socket';

export default {
    namespaced: true,
    state: {
        sessionId: null,
        socket: null,
    },
    getters: {
        scene(state, getters, rootState, rootGetters) {
            const {isLogin, isPresale} = rootState;
            switch (true) {
                case !isPresale: return 'AFTER_SALE';
                case isLogin: return 'PRE_SALE';
                default: return 'PRE_SALE_TOURIST';
            }
        },
    },
    mutations: {
        saveSession(state, sessionId) {
            if (sessionId === state.sessionId) {
                return;
            }
            this.commit('chat/clearSocket');
            state.sessionId = sessionId;
            this.commit('chat/createSocket');
        },
        clearSocket(state) {
            if (state.socket) {
                state.socket.close();
            }
            if (state.unload) {
                state.unload();
                state.unload = null;
            }
            state.socket = null;
        },
        createSocket(state) {
            state.socket = createWebSocket(state.sessionId, this);
            const {isTourist} = this.state;
            if (isTourist) {
                // 游客模式下，添加离开的弹窗提示
                state.unload = loadEvent();
            }
        },
    },
    actions: {
        async transformIM({commit, getters, rootGetters, rootState}, payload) {
            const isInRes = await isIninWhitelist({
                scene: getters.scene,
            });

            // 不在白名单中
            if (!(isInRes && isInRes.data && isInRes.data.inWhiteList)) {
                throw new Error();
            }

            const res = await getIMSessions({
                ...payload,
                userName: rootGetters.touristUserName,
                scene: getters.scene,
                source: rootState.source,
            });
            if (res.success) {
                const {createSuccess, sessionId, welcome = ''} = res.data;
                // 创建会话成功
                if (createSuccess) {
                    const obj = { // 发送问候语
                        dialogId: -(new Date().getTime()),
                        dialogInfo: {
                            content: welcome,
                            display: DISPLAY_TYPE.HTML,
                        },
                        dialogType: DIALOG_TYPE.TS,
                        dialogTime: Date.now(),
                    };
                    commit('setChatRecordsList', [obj], {root: true});
                    // 创建ws
                    commit('saveSession', sessionId);
                    return;
                }
            }
            throw new Error();
        },
        // 转人工，触发坐席分配
        async getSessionInfo({commit, dispatch, rootState}, payload) {
            try {
                await dispatch('transformIM', payload);
            }
            // 分配失败
            catch {
                const replyObj = [{
                    dialogId: -(new Date().getTime()),
                    dialogInfo: {
                        content: '',
                        display: DISPLAY_TYPE.HTML,
                    },
                    dialogType: DIALOG_TYPE.TS,
                    dialogTime: Date.now(),
                }];
                if (!rootState.isPresale) {
                    // 处理跳转工单
                    const url = new URL(constant.true.ticketDomainNew);
                    const params = await getTicket();
                    url.hash = '#/ticket/create';
                    const ticketUrl = url.toString() + '?useticket=1' + params;
                    replyObj[0].dialogInfo.content
                        = `您的问题需补充更多详细信息以便我们为您提供支持，点此<a href="${ticketUrl}">创建工单</a>我们会尽快为您解决。`;
                }
                else {
                    replyObj[0].dialogInfo.content
                        = `非常抱歉，当前暂时无法为您提供在线咨询服务，您可<a href="${constant.true.contactUsLink}">提交留言</a>，我们收到后会尽快进行回复，谢谢。`;
                }
                commit('setChatRecordsList', replyObj, {root: true});
            }
        },
        // 发送消息
        async send({state, rootState, rootGetters}, {content, file}) {
            try {
                const res = await sendMessage({
                    channel: CHANNEL,
                    sessionId: state.sessionId,
                    content,
                    file,
                    userName: rootGetters.touristUserName,
                });
                if (!res.success) {
                    Vue.prototype.$message.error(res.message && res.message.global);
                }
            }
            catch {

            }
        },
        // 标记单条消息已读
        async cleanSingleMsg({rootState}, dialogId) {
            try {
                await cleanSingleUnreadMsg(dialogId, {status: 1});
            }
            catch (e) {
                console.log(e);
            }
        },
        async checkSocket({state}) {
            if (state.socket) {
                Message.warning('您当前已进入人工服务环节，如有任何疑问可直接进行反馈');
            }
            return !!state.socket;
        },
    },
};
